class CheckCallable {
	Call(node) {
		console.log('check callable', node)
	}
}

import traverse	from '../util/traverse'

const visitors = []
visitors.push(new CheckCallable)

export default function lint(tree) {
	return tree::traverse(node => {
		for (const visitor of visitors) {
			visit(visitor, node)
			if (node.nodeValue) visitExpression(visitor, node.nodeValue)
		}
	}, undefined, true)
}

function visit(visitor, node) {
	const {nodeType} = node
	if (typeof visitor[nodeType] === 'function') visitor[nodeType](node)
}

function visitExpression(visitor, expr) {
	const [type] = expr
	if (typeof visitor[type] === 'function') visitor[type](expr)
}
